import { parse, format, addMinutes, addHours } from 'date-fns';

export const formatHorario = (horario, roomType) => {
  //Verifica se roomType é uma string antes de usar replace
  const normalizedRoomType = roomType.replace(/\d+$/, '').trim().toLowerCase();

  const startTime = parse(horario, "HH:mm", new Date());
  let endTime;

  if (normalizedRoomType === "sala de atendimento" || normalizedRoomType === "sala de reuniões") {
    if (format(startTime, "HH:mm") === "17:00") {
      endTime = addMinutes(startTime, 30);
    } else {
      endTime = addHours(startTime, 1);
    }
  } else {
    endTime = addHours(startTime, 1);
  }

  return `${format(startTime, "HH:mm")} às ${format(endTime, "HH:mm")}`;
};